import React, { useEffect, useRef } from "react";
import CG_FooterButtons from "./CG_FooterButtons";
import CG_Header from "./CG_Header";
import Page1 from "../../assets/images/seller_page-0001.png";
import Page2 from "../../assets/images/seller_page-0002.png";
import Page3 from "../../assets/images/seller_page-0003.png";
import Page4 from "../../assets/images/seller_page-0004.png";
import SignatureCanvas from "react-signature-canvas";

export default function CG_ESignContract() {
    const canvaPageOne = useRef(null);
    const canvaPageThree = useRef(null);
    const addressInputRef = useRef(null);
    const sigCanvasRef = useRef();

    useEffect(() => {
        drawFullNameOnPage();
        drawCurrentDateonPageThree();
    }, []);
    const drawFullNameOnPage = (firstName, lastName) => {
        const fullName = `${firstName} ${lastName}`;
        const canvas = canvaPageOne.current;
        if (canvas) {
            const ctx = canvas?.getContext("2d");
            const img = new Image();
            img.onload = () => {
                const aspectRatio = img.width / img.height;
                canvas.width = img.width;
                canvas.height = canvas.width / aspectRatio;
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                ctx.font = "bold 30px Arial";
                ctx.fillStyle = "red";
                const x = canvas.width / 11;
                const y = canvas.height / 2.65;
                ctx.fillText(fullName, x, y);
            };

            img.src = Page1;
        }
    };
    const drawCurrentDateonPageThree = () => {
        const canvas = canvaPageThree.current;
        if (canvas) {
            const ctx = canvas?.getContext("2d");
            const img = new Image();
            img.onload = () => {
                const aspectRatio = img.width / img.height;
                canvas.width = img.width;
                canvas.height = canvas.width / aspectRatio;
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                ctx.font = "bold 30px Arial";
                ctx.fillStyle = "red";
                const x = canvas.width / 1.26;
                const y = canvas.height / 1.62;
                ctx.fillText(new Date().toLocaleDateString(), x, y);
            };

            img.src = Page3;
        }
    };

    const drawSignatureonPageFour = () => {
        const canvas = canvaPageThree.current;
        if (canvas) {
            const ctx = canvas?.getContext("2d");
            const img = new Image();
            img.onload = () => {
                const aspectRatio = img.width / img.height;
                canvas.width = img.width;
                canvas.height = canvas.width / aspectRatio;
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                const x = canvas.width / 6.5;
                const y = canvas.height / 1.7;
                ctx.drawImage(sigCanvasRef.current.getCanvas(), x, y);
                ctx.font = "bold 30px Arial";
                ctx.fillStyle = "red";
                const dateX = canvas.width / 1.26;
                const dateY = canvas.height / 1.62;
                ctx.fillText(new Date().toLocaleDateString(), dateX, dateY);
            };
            img.src = Page3;
        }
    };
    return (
        <div className="tw-h-[calc(90vh)] tw-overflow-hidden">
            <CG_Header screen="preview-contract" />
            <div className="tw-p-10 tw-px-[5%] tw-text-[#001659]">
                <div className="tw-w-full tw-mt-5">
                    <div className="tw-flex tw-gap-10 ">
                        <div className="tw-w-full xl:tw-w-1/2 tw-h-[calc(70vh)] tw-overflow-auto">
                            <div>
                                <h1 className="tw-underline tw-font-[700] tw-text-[25px] tw-mb-4 tw-text-[#001659]">E- Sign your Contract</h1>
                                <p>Sign Here</p>
                            </div>
                            <div className="tw-flex tw-items-center tw-my-5 tw-gap-5">
                                <button className="tw-p-2 tw-rounded-md tw-border tw-border-gray-400 tw-bg-secondary hover:tw-bg-secondary_hover tw-text-white">
                                    Sign
                                </button>
                                <button className="tw-p-2 tw-rounded-md tw-border tw-border-gray-400">Type</button>
                                <button className="tw-p-2 tw-rounded-md tw-border tw-border-gray-400">Upload File</button>
                            </div>
                            <SignatureCanvas
                                ref={sigCanvasRef}
                                onEnd={() => drawSignatureonPageFour()}
                                penColor="#232D8E"
                                canvasProps={{
                                    className: "tw-w-full",
                                    style: {
                                        height: 300,
                                        backgroundColor: "#f7f7f7",
                                    },
                                }}
                            />
                            <p className="tw-mt-5 tw-text-[#001659] tw-text-[15px]">
                                By signing the above e-signature, I agree that such signature will be as valid as handwritten signatures to the extent
                                allowed by local law.
                            </p>
                            <div className="tw-flex tw-items-center tw-mt-3 tw-gap-5 tw-text-white">
                                <button className="tw-rounded-md tw-px-5 tw-bg-[#7C7C7C] tw-py-2">Cancel</button>
                                <button className="tw-rounded-md tw-px-5 tw-bg-[#12B76A] tw-py-2">Accept And sign</button>
                            </div>
                        </div>
                        <div className="tw-w-1/2 tw-h-[calc(70vh)] tw-overflow-auto">
                            <h1 className="tw-underline tw-font-[700] tw-text-[25px] tw-mb-4 tw-text-[#001659]">Preview your contract</h1>
                            <canvas ref={canvaPageOne} className="tw-w-full tw-h-auto tw-mb-10"></canvas>
                            <img src={Page2} alt="" className="pdf-image" />
                            <canvas ref={canvaPageThree} id="last" className="tw-w-full tw-h-auto tw-mb-10"></canvas>
                            <div className="seller-date" id="currentDate"></div>
                            <img src={Page4} alt="Image" className="tw-w-full tw-h-auto tw-mb-10" />
                        </div>
                    </div>
                </div>
                <CG_FooterButtons />
            </div>
        </div>
    );
}
